import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { CourseDialogBoxComponent } from '../course-dialog-box/course-dialog-box.component';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
@Component({
  selector: 'app-course-data',
  templateUrl: './course-data.component.html',
  styleUrls: ['./course-data.component.scss']
})
export class CourseDataComponent implements OnInit {
  CourseSearchForm: FormGroup;
  APIService: string;
  dialogRef: MatDialogRef<any>;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  courseList: any; 
  sortedData: any[];
  sortColumn: string = '';  // Track the currently sorted column
  sortDirection: string = 'asc';
  SessionNo: any;
  UserCollege
userPermission
  setIntervalSearch: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    public router: Router,
    private spinner:NgxSpinnerService) 
    { this.APIService = environment.serviceUrl; }
  
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.getCourseData();
    this.CourseSearchForm = this.fb.group({
      SearchString: new FormControl('')
    })
    window.scroll(0, 0);
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getCourseData();
    // this.keypress()
  }
  
  getCourseData() {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['CgCode'] = this.UserCollege
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      this.courseList = res.data;
      this.totalItems = res.data[0].TotalRecords;
      this.sortedData = [...this.courseList];
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.courseList = [];
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
 
 
  addnewrecord() {
    const dialogRef = this.dialog.open(CourseDialogBoxComponent, {
      width: '120vh',
      data: {key : "New"},
      disableClose: true  
    }); 
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getCourseData();
      this.CourseSearchForm.controls['SearchString'].setValue('');
    });
  }

  editData(k){
    const dialogRef = this.dialog.open(CourseDialogBoxComponent, {
      width: '120vh',
      data: { selected: k, key : "Edit"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
        this.getCourseData();
        this.CourseSearchForm.controls['SearchString'].setValue('');
    });
  }

  deleteData(k){
    const dialogRef = this.dialog.open(CourseDialogBoxComponent, {
      width: '120vh',
      data: { selected: k, key : "Delete"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
        this.getCourseData();
        this.CourseSearchForm.controls['SearchString'].setValue('');
    });
  }

  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.courseList = [];
    const payload = {};
    payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    payload['SearchString'] = this.CourseSearchForm.value['SearchString'];
    // payload['SearchString'] = this.CourseSearchForm.value;
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.getCourse(payload).subscribe(
      (res) => {
        if(res.status){
          this.courseList = res.data;
          this.totalItems = res.data[0].TotalRecords;
        }
        else{
          this.courseList = [];
        this.totalItems = 0
        }
       
        }, (ERROR: HttpErrorResponse) => {
        this.courseList = [];
        this.totalItems = 0
      });
    // this.umsService.getCourse(this.CourseSearchForm.value).subscribe(res => {
    //   this.courseList = res.data;
    //   this.totalItems = res.data[0].TotalRecords;
    // }, (ERROR: HttpErrorResponse) => {
    //   this.courseList = [];
    // });
    },1000)
   
 
  }

  Print(){
    let submitpayload = this.CourseSearchForm.value;
    let payload1 = {}
    payload1['SearchString'] = submitpayload['SearchString'],
    payload1['MenuName'] ='Master-Courses';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 109,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

}
 